"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_battery__low__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2636e064-8f20-4fa1-aee1-9c866d5d1639",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "389195e3-7aaf-4817-bca5-a75af0cbe67d",
    x1: 149.66,
    y1: 88.99,
    x2: 174.81,
    y2: 114.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "battery-low-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "1e67a0ce-0666-4ba8-b794-104354090b57",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e2c58d5-349a-4ace-9e73-9c497235fffa",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "996fb647-bae2-48e6-8300-407d2138c36e",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "52ef997f-7505-4563-8c73-2c6370079fd8",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f792cdff-8826-42a1-b59b-e699663ea755",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e2603f2-d044-4abe-be81-66898326fa23",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "713da604-8884-4777-b36e-ba984ffbc177",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3cb6b77d-9069-44cf-af67-7ad32bb97393",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,84V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72v48a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16V84Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 108,
    x2: 44,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 108,
    x2: 68,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 108,
    x2: 92,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,120a12,12,0,0,0,12-12V94.65l-16-16V120Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#389195e3-7aaf-4817-bca5-a75af0cbe67d)"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    d: "M144,134H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,118h-4v2h4a12,12,0,0,0,12-12v-2A12,12,0,0,1,164,118Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }));
}

var _default = ic_battery__low__dark;
exports.default = _default;